import {connectRouter} from 'connected-react-router';
import {combineReducers} from 'redux';
import {persistReducer} from 'redux-persist';
import autoMergeLevel1 from 'redux-persist/lib/stateReconciler/autoMergeLevel1';
import storage from 'redux-persist/lib/storage';
import agentReducer from './agent';
import langReducer from './language';
import settingsReducer from './settings';

const storeConfig = {key: 'store', storage, blacklist: ['stores']};
// const settingsConfig = { key: 'settings', storage };
const rootConfig = {
    key: 'root',
    storage,
    stateReconciler: autoMergeLevel1,
};
// const agentConfig = { key: 'agent', storage };

// const agents = persistReducer( agentConfig, agentReducer);

export default history =>
    persistReducer(
        rootConfig,
        combineReducers({
            router: connectRouter(history),
            settings: settingsReducer,
            agents: agentReducer,
            language: langReducer,
        })
    );
